<bb-page-header 
	[icon]="'list-ol'" 
	[title]="'PLAYLISTS' | translate" 
	[filterConfig]="filterConfig"
	[currentPath]="listConfiguration.activePath">	
</bb-page-header>

<div class="body-column">

	<a class="button" [routerLink]="['/library/playlist/new_dynamic', 'general']" title="{{ 'PLAYLIST_BASED_ON_RULES' | translate }}"><i class="fa fa-magic"></i>
		<span class="short-label">{{ 'SMART_PLAYLIST' | translate }}</span>
		<span class="long-label">{{ 'CREATE_NEW_SMART_PLAYLIST' | translate }}</span>
	</a>

	<a class="button" [routerLink]="['/library/playlist/new_static', 'general']" title="{{ 'PLAYLIST_BASED_ON_SELECTION' | translate }}"><i class="fa fa-plus"></i>
		<span class="short-label">{{ 'STATIC_PLAYLIST' | translate }}</span>
		<span class="long-label">{{ 'CREATE_NEW_STATIC_PLAYLIST' | translate }}</span>
	</a>

	<bb-table-container>

		<bb-table-header>
			<bb-table-header-cell class="icon"></bb-table-header-cell>
			<bb-table-header-cell property="title">{{ 'TITLE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="author">{{ 'AUTHOR' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="createddate" class="date" >{{ 'CREATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="createdBy">{{ 'CREATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="updateddate" class="date" >{{ 'UPDATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="updatedBy">{{ 'UPDATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="status" class="icon">&nbsp;</bb-table-header-cell>
			<bb-table-header-cell class="buttons"></bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngFor="let row of rows" [row]="row">
			<bb-table-cell class="icon"><i class="fa fa-magic" [hidden]="row.data.listtype === 'static'"></i></bb-table-cell>
			<bb-table-cell property="title" class="overflow">{{ row.data.title }}</bb-table-cell>
			<bb-table-cell property="author">{{ row.data.author }}</bb-table-cell>
			<bb-table-cell property="createddate" class="date" [titleValue]="row.data.createddate | bbDate">{{ row.data.createddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="createdBy" [titleValue]="row.data.createdBy">{{ row.data.createdBy }}</bb-table-cell>
			<bb-table-cell property="updateddate" class="date" [titleValue]="row.data.updateddate | bbDate">{{ row.data.updateddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="updatedBy" [titleValue]="row.data.updatedBy">{{ row.data.updatedBy }}</bb-table-cell>
			<bb-table-cell property="status" class="icon"><span [innerHTML]="row.data | statusIcon"></span></bb-table-cell>
			<bb-table-cell class="buttons">

				<a class="button" [routerLink]="['/library/playlist', row.data.id, 'general']">
					<i class="fa fa-edit" (easterEgg)="showData(row.id)" ></i>
				</a>
				<a class="button" (click)="showPreview(row.data)">
					<i class="fa fa-eye"></i>
				</a>
				<a class="button" [ngClass]="{disabled: !deleteRight}" (click)="deleteSingle(row.data)">
					<i class="fa fa-trash"></i>
				</a>

			</bb-table-cell>
		</bb-table-row>

	</bb-table-container>

	<div class="no-results" *ngIf="rows && !rows.length">{{ 'NO_PLAYLISTS_FOUND' | translate }}</div>

	<bb-table-pager></bb-table-pager>

</div>
